const SAFE_USER_FIELDS = ['userId', 'id', 'username', 'nickname', 'avatar'];

const pickSafeUserInfo = (info) => {
  if (!info || typeof info !== 'object') return {};
  const result = {};
  for (const field of SAFE_USER_FIELDS) {
    if (info[field] !== undefined && info[field] !== null && info[field] !== '') {
      result[field] = info[field];
    }
  }
  return result;
};

export const updateAxiosHeader = () => {}

export const clearToken = () => {}

export const updateUserInfo = (userInfo) => {
  const safe = pickSafeUserInfo(userInfo);
  if (safe && Object.keys(safe).length > 0) {
    localStorage.setItem('userInfo', JSON.stringify(safe))
  } else {
    localStorage.removeItem('userInfo')
  }
}

export const clearUserInfo = () => {
  localStorage.removeItem('userInfo')
  localStorage.removeItem('token')
}

export const getUserInfo = () => {
  try {
    const userStr = localStorage.getItem('userInfo')
    if (!userStr) return {}
    const userInfo = JSON.parse(userStr)
    if (typeof userInfo !== 'object' || userInfo === null) {
      clearUserInfo()
      return {}
    }
    return pickSafeUserInfo(userInfo)
  } catch (e) {
    clearUserInfo()
    return {}
  }
}

export { pickSafeUserInfo };
